export const setupNoticiaEventos = () => {
  if (document.querySelector(".eventos")) {
    let eventos = document.querySelectorAll(`.eventos .noticia`);
    eventos.forEach((evento) => {
      evento.addEventListener("click", () => {
        let eventoUrl = evento
          .querySelector(".noticia__titulo__link")
          .getAttribute("href");
        console.log(eventoUrl);
        window.location.href = eventoUrl;
      });
    });
  }

  if (document.querySelector(".eventos__calendario_contenedor")) {
    let eventos = document.querySelectorAll(
      `.eventos__calendario_evento .noticia`
    );
    eventos.forEach((evento) => {
      evento.addEventListener("click", () => {
        let eventoUrl = evento
          .querySelector(".noticia__titulo__link")
          .getAttribute("href");
        console.log(eventoUrl);
        window.location.href = eventoUrl;
      });
    });
  }
};
